// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"tK-z","smallCardRow":"uK-z","largeCardRow":"vK-z","productSearchRow":"wK-z","curatedRow":"xK-z"};